const mapBadges = (badges) => badges.flatMap((badge) => {
  switch (badge) {
    case "networkHome": {
      return "network_home";
    }
    case "unreadChats": {
      return "unseen_messages";
    }
    default:
      return [badge];
  }
});
export {
  mapBadges
};
